import React from "react";
import { BrandMark } from "@/components/BrandMark";

/**
 * SiteFooter — the global footer.
 * Minimal by design: brand mark + tagline + copyright line. Editable page
 * structure was removed at the member's request; the footer is intentionally
 * quiet and does not carry fillable placeholders anymore.
 */

export default function SiteFooter() {
  return (
    <footer
      className="mt-16 border-t hairline bg-[hsl(var(--bg))]"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-8">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div>
            <div className="font-display text-lg tracking-tight" data-testid="site-footer-brand">
              <BrandMark signOnMount={false} idleWhisper={false} testid="site-footer-brand-mark" />
            </div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--muted-foreground))] mt-1">
              The Art Of Becoming
            </div>
          </div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--muted-foreground))] flex items-center gap-3 flex-wrap justify-end">
            <span>© <BrandMark signOnMount={false} idleWhisper={false} testid="site-footer-copyright-mark" /></span>
            <span className="italic normal-case tracking-normal text-[hsl(var(--muted-foreground))]">
              Move through your life with intention.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
